export default __webpack_public_path__ + "static/media/message-icon.269072b3.svg";